// extracted by mini-css-extract-plugin
export default {"root":"styles_root__0cr-i","logo":"styles_logo__XJMgc","menuItem":"styles_menuItem__dHhDG","navItems":"styles_navItems__cilJ7","navItem":"styles_navItem__OcTbe"};